"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GamepadContext_1 = require("../GamepadContext");
var FOCUSABLE = '[tabindex]:not([data-focus-guard])';
var getActiveScope = function (fallback) {
    if (document.querySelector('[data-gamepad-modal]'))
        return null;
    var modals = document.querySelectorAll('.modals-container');
    for (var _i = 0, modals_1 = modals; _i < modals_1.length; _i++) {
        var modal = modals_1[_i];
        if (modal.children.length > 0)
            return modal;
    }
    var dropdown = fallback === null || fallback === void 0 ? void 0 : fallback.querySelector('[class*="dropdown"][class*="open"]');
    if (dropdown)
        return dropdown;
    return fallback;
};
var useContentGamepadNavigation = function (sectionRef, gamepadHandlerId) {
    var gamepad = (0, GamepadContext_1.useGamepad)();
    var lastFocused = (0, react_1.useRef)(null);
    var wasInOverlay = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var handleGamepadNavigation = function (direction) {
            var _a, _b;
            var scope = getActiveScope(sectionRef.current);
            var inOverlay = scope !== sectionRef.current;
            if (inOverlay && !wasInOverlay.current) {
                var focused = (_a = sectionRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(':focus');
                if (focused)
                    lastFocused.current = focused;
            }
            wasInOverlay.current = inOverlay;
            var elements = Array.from((scope === null || scope === void 0 ? void 0 : scope.querySelectorAll(FOCUSABLE)) || []);
            if (elements.length === 0)
                return;
            var activeElement = (_b = (scope !== null && scope !== void 0 ? scope : document)) === null || _b === void 0 ? void 0 : _b.querySelector(':focus');
            if (!activeElement) {
                elements[0].focus();
                return;
            }
            var closestElement = null;
            var cur = activeElement.getBoundingClientRect();
            var cx = cur.left + cur.width / 2;
            var cy = cur.top + cur.height / 2;
            var closestDistance = Infinity;
            elements.forEach(function (el) {
                if (el === activeElement)
                    return;
                var r = el.getBoundingClientRect();
                var ex = r.left + r.width / 2;
                var ey = r.top + r.height / 2;
                var isCorrectDirection = (direction === 'left' && ex < cx) ||
                    (direction === 'right' && ex > cx) ||
                    (direction === 'up' && ey < cy) ||
                    (direction === 'down' && ey > cy);
                if (!isCorrectDirection)
                    return;
                var dx = ex - cx;
                var dy = ey - cy;
                var isHorizontal = direction === 'left' || direction === 'right';
                var primary = isHorizontal ? Math.abs(dx) : Math.abs(dy);
                var secondary = isHorizontal ? Math.abs(dy) : Math.abs(dx);
                var distance = primary + secondary * 3;
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestElement = el;
                }
            });
            if (closestElement) {
                closestElement.focus();
            }
        };
        var onSelect = function () {
            var _a, _b;
            var scope = getActiveScope(sectionRef.current);
            var inOverlay = scope !== sectionRef.current;
            if (inOverlay && !wasInOverlay.current) {
                var focused = (_a = sectionRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(':focus');
                if (focused)
                    lastFocused.current = focused;
            }
            wasInOverlay.current = inOverlay;
            var elements = Array.from((scope === null || scope === void 0 ? void 0 : scope.querySelectorAll(FOCUSABLE)) || []);
            if (elements.length === 0) {
                if (lastFocused.current) {
                    lastFocused.current.focus();
                    wasInOverlay.current = false;
                }
                return;
            }
            var activeElement = (_b = (scope !== null && scope !== void 0 ? scope : document)) === null || _b === void 0 ? void 0 : _b.querySelector(':focus');
            if (!activeElement) {
                elements[0].focus();
                return;
            }
            var isSelect = Array.from(activeElement.classList).some(function (cls) { return cls.startsWith('select-input'); });
            if (!isSelect) {
                activeElement === null || activeElement === void 0 ? void 0 : activeElement.click();
                requestAnimationFrame(function () {
                    var stillInOverlay = getActiveScope(sectionRef.current) !== sectionRef.current;
                    if (!stillInOverlay && wasInOverlay.current && lastFocused.current) {
                        lastFocused.current.focus();
                        wasInOverlay.current = false;
                    }
                });
            }
        };
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('analog', gamepadHandlerId, handleGamepadNavigation);
        gamepad === null || gamepad === void 0 ? void 0 : gamepad.on('buttonA', gamepadHandlerId, onSelect);
        return function () {
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('analog', gamepadHandlerId);
            gamepad === null || gamepad === void 0 ? void 0 : gamepad.off('buttonA', gamepadHandlerId);
        };
    }, [gamepad, gamepadHandlerId, sectionRef]);
};
exports.default = useContentGamepadNavigation;
